import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getFiles as getFilesApi,
  importFile as importFileApi,
  deleteBatch as deleteBatchApi,
} from "../../apiCalls/caller";

export const getFiles = createAsyncThunk("files/getFiles", async () => {
  try {
    const response = getFilesApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const importFile = createAsyncThunk("files/importFile", async (data) => {
  try {
    const response = importFileApi(data);
    return response;
  } catch (error) {
    return error;
  }
});

export const deleteBatch = createAsyncThunk(
  "files/deleteBatch",
  async (data) => {
    try {
      const response = deleteBatchApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);